import { SelectOption } from '@components/atoms/ReactSelect';

export const DOCUMENT_CATEGORIES_OPTIONS: SelectOption[] = [
  { value: 'TASK', label: 'Task' },
  { value: 'PERMIT', label: 'Permit' },
  { value: 'DRAWINGS', label: 'Drawings' },
  { value: 'INVOICE', label: 'Invoice' },
  { value: 'BILL_OF_MATERIALS', label: 'Bill of Materials' },
  { value: 'RECEIPTS', label: 'Receipts' },
  { value: 'PHOTO', label: 'Photo' },
  { value: 'CONTRACT_CHANGE_ORDER', label: 'Contract (Change Order)' },
  { value: 'PURCHASE_ORDER', label: 'Purchase Order' },
  { value: 'SUBCONTRACTOR_AGREEMENT', label: 'Subcontractor Agreement' },
  { value: 'OTHER', label: 'Other' },
];

export const CATEGORY_ACTIVITY = 'ACTIVITY';
